import { SelectItem } from 'primeng/api';
import { GenericValue } from '../../core/model/generic-value';

export enum HisDynamicFieldType {
    Text = 'Text',
    Select = 'Select',
    MultiSelect = 'MultiSelect',
    Checkbox = 'Checkbox',
    Password = 'Password',
    TreeSelect = 'TreeSelect',
    MultiTreeSelect = 'MultiTreeSelect',
    DatePicker = 'DatePicker',
    TextArea = 'TextArea',
    RadioButton = 'RadioButton',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    TreeSelect_Institution_Person = 'TreeSelect_Institution_Person',
    Comment = 'Comment',
    Label = 'Label',
    HiddenField = 'HiddenField',
    Anchor = 'Anchor',
    FileUpload = 'FileUpload',
    Form = 'Form',
    Fieldset = 'Fieldset',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    CurrentlyUnknown_999 = 'CurrentlyUnknown_999',
    KeytableSelect = 'KeytableSelect',
    KeytableMultiSelect = 'KeytableMultiSelect',
    Chips = 'Chips',
    YesNoSelect = 'YesNoSelect',
    YesNoWithTextArea = 'YesNoWithTextArea',
    DeclarationFieldset = 'Declaration-Fieldset',
    Floatnumber = 'Floatnumber'
}

export class HisDynamicFieldConfig {
    name: string; // GS: path (eindeutiger identifier)
    controlType: HisDynamicFieldType;
    label: string;
    helptext?: string;
    required?: boolean;
    oldValue?: any;
    useOldValue?: boolean;
    defaultValue?: any;
    ddKey?: string;
    disabled?: boolean;
    height?: number;
    showNullItem?: boolean; // Der gesuchte Datensatz enthält null
    items?: SelectItem[];
    typeAheadUrl?: string;
    treeName?: string;
    subSearchConfiguration?: string; // sub-search configuration file
    subSearchEntity?: string; // name of the entity whose data is selectable in the autocomplete field
    visibleInSimplifiedForm?: boolean;
    children?: HisDynamicFieldConfig[];
    customOptionsMethod?: boolean; // Anzeige einer Tabelle für KeytableMultiSelect-Optionen in einem Overlay; für sehr große Auswahllisten geeignet
    customOptions?: GenericValue[]; // Große Auswahlliste für KeytableMultiSelect
    showLabelTop?: boolean;
}

export function searchFieldConfig(
    fieldConfigTree: HisDynamicFieldConfig,
    searchCriterion: ( config: HisDynamicFieldConfig ) => boolean
): HisDynamicFieldConfig {
    // if ( !fieldConfigTree ) {
    //     return null;
    // } else
    if ( searchCriterion( fieldConfigTree ) ) {
        return fieldConfigTree;
    } else if ( fieldConfigTree.children !== undefined ) {
        for ( let config of fieldConfigTree.children ) {
            let matchingConfig = searchFieldConfig( config, searchCriterion );
            if ( matchingConfig !== null ) {
                return matchingConfig;
            }
        }
    }
    return null;
}

